import { render, staticRenderFns } from "./PostExplanation.vue?vue&type=template&id=2719ec04"
import script from "./PostExplanation.vue?vue&type=script&lang=js"
export * from "./PostExplanation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports